export const DESCRIPTION: Record<string, string> = {
    businessweek:
        "Bloomberg Businessweek helps global leaders stay ahead with insights and in-depth analysis on the people, companies, events, and trends shaping today's complex, global economy",
    green: "Climate news and data-driven insights from Bloomberg's global newsroom covering the latest in science, environmental impacts, zero-emission tech and green finance — with a focus on solutions",
    markets:
        "Bloomberg delivers business and markets news, data, analysis, and video to the world, featuring stories from Businessweek and Bloomberg News on everything pertaining to markets",
};

export const enum MAGAZINE_MODULE_TITLES {
    FEATURE = "Features",
}
